import "@/assets/css/styles.css";
import "@/assets/css/common.css";

import Vue from "vue";
// import ElementUI from 'element-ui';
// import 'element-theme-chalk';

import App from "./App.vue";
import Scrollspy from 'vue2-scrollspy';
import BootstrapVue from 'bootstrap-vue'
// import VueYoutube from 'vue-youtube'
import VueParticles from 'vue-particles'
import http from 'axios'
Vue.prototype.$http = http
import router from "./router";
import Viewer from 'v-viewer';
 
import 'viewerjs/dist/viewer.css';
 
Vue.use(Viewer,{
  defaultOptions: {
    zIndex:9999,
  }
});
//Swiper3
require('swiper/dist/css/swiper.css')
// import
import VueAwesomeSwiper from 'vue-awesome-swiper'
// mount with global
Vue.use(VueAwesomeSwiper)
import './plugin/index'
 

 
 
var VueScrollTo = require('vue-scrollto');

Vue.use(VueParticles)
// Vue.use(VueYoutube)
Vue.use(VueScrollTo)
// Vue.use(ElementUI);
Vue.use(BootstrapVue);

Vue.use(Scrollspy);
Vue.config.productionTip = false;
Vue.prototype.$ossUrl = 'http://public-aaf-shenzhen-file.oss-cn-beijing.aliyuncs.com/webStatic/newCompany/';
new Vue({
  router,
  el: '#app',
  render: h => h(App)
}).$mount("#app");
